import { inject, Injectable } from '@angular/core';
import { computed } from '@angular/core';
import { OrderApiResponseStateService } from '../../../order-api-response/order-api-response-state.service';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { VideoPackageSelectionData } from '../../../../../../../models/order/workflow/video/video-package-selection.model';
import { VideoFlowStateService } from '../video-flow-state.service';



@Injectable({ providedIn: 'root' })
export class VideoPackageSelectionStateService extends BaseWorkflowStateService<VideoPackageSelectionData> {
    private orderApiResponseState: OrderApiResponseStateService = inject(OrderApiResponseStateService);
    private flowStateService = inject(VideoFlowStateService);
    private _apiData = this.orderApiResponseState.apiData;
    protected override stateKey: string = 'videoPackageSelection';
    /** Data slice for the Order Setup step */
    videoState = this.flowStateService.state;

    /** API Data */
    apiData = computed(() => this._apiData());
    serviceAvailabilityData = this.orderApiResponseState.serviceAvailabilityData;
    customer = this.orderApiResponseState.customer;

    isPlanSelected = computed(() => !!this.state()?.selectedPlanCode);

    updateProvider(value: string) {
        this.flowStateService.updateData({ provider: value });
    }

    updatePackageType(value: string) {
        this.flowStateService.updateData({ packageType: value });
    }

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ videoPackageSelection: this.state() });
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}
